import { getCalibratedPredictionPerScore } from "./getCalibratedPredictionPerScore";
import {
  calculateScoresColorsBasedOnPathogenicity,
  getColorBasedOnPathogenicity,
} from "./calculateScoresColors";
import { getCalibratedPrediction } from "./getCalibratedPrediction";

const splitFirstOccurrence = (str, separator) => {
  const [first, ...rest] = str.split(separator);
  const remaining = rest.join(separator);
  return { first, remaining };
};

export const setCalculatedInformationPerDb = (databases) => {
  /* Set pathogenicity and color for each one of the databases and scoresColors 
    which is an array with all the corresponding colors for each prediction. */
  return databases.map((db) => {
    /* Returns an array of pathogenicities using databaseThresholds and scores,
    eg. -> [], ["Pathogenic Moderate","Pathogenic Strong"], ["Benign Moderate"], ["Unknown"] */
    const calibratedPredictionPerScore = getCalibratedPredictionPerScore(
      db.thresholds,
      db.scoresArray
    );
    const colorPerScore = calculateScoresColorsBasedOnPathogenicity(
      calibratedPredictionPerScore
    );
    const scoresArr = db.scoresArray.map((obj, i) => {
      return {
        ...obj,
        calibratedPrediction: calibratedPredictionPerScore?.[i],
        color: colorPerScore?.[i],
      };
    });

    /* This function returns the Calibrated Prediction column that will be rendered for each database,
      e.g. "Unknown" , "Likely Benign", etc. 
      scores is an array of numbers e.g. [null, null, null, 0.986356512902] */
    const calibratedPrediction = getCalibratedPrediction(
      db.thresholds,
      db.scores
    );
    /* This function returns the color of the text displayed in the Calibrated Prediction column of each database. */
    const calibratedPredictionColor =
      getColorBasedOnPathogenicity(calibratedPrediction);

    /* Strength and pathogenicity are used in genericHelpers.js to calculate the number displayed on the horizontal bar. */
    const calibratedPred = splitFirstOccurrence(calibratedPrediction, " ");
    const pathogenicity = calibratedPred?.first;
    const strength = calibratedPred?.remaining;
    return {
      ...db,
      calibratedPredictionPerScore,
      colorPerScore,
      calibratedPrediction,
      calibratedPredictionColor,
      strength,
      pathogenicity,
      scoresArray: scoresArr,
    };
  });
};
